var map = {
	"./custom/app/shared/object-collection/shared/badges/badges.component": [
		39214,
		[
			"src_themes_custom_app_shared_object-collection_shared_badges_badges_component_ts"
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 70295;
module.exports = webpackAsyncContext;